export default "__VITE_ASSET__32e1e493__"